/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */
'use strict';

/**
 * @function takeFromMarkup
 */
module.exports = function () {
  let packet = [];

  if (typeof window !== 'undefined' && window.__reactTransmitPacket instanceof Array) {
    packet = window.__reactTransmitPacket.slice(0);
    delete window.__reactTransmitPacket;
  }

  return packet;
};
